
// import React, { useState } from 'react';
// import axios from 'axios';
// import { Button, Table, Form, Container, Row, Col } from 'react-bootstrap';
// import Sidebar from '../Sidebar/Sidebar';

// function StockReport() {
//     const [date_1, setDate1] = useState('');
//     const [date_2, setDate2] = useState('');
//     const [data, setData] = useState([]);
//     const [loading, setLoading] = useState(false);

//     const handleDateSubmit = async () => {
//         if (date_1 && date_2) {
//             setLoading(true);
//             try {
//                 const response = await axios.post('https://posapi.emedha.in/api/getPurchasesWithStock', {
//                     date_1,
//                     date_2
//                 });
//                 setData(response.data);
//             } catch (error) {
//                 console.error('Error fetching data:', error);
//             }
//             setLoading(false);
//         } else {
//             alert('Please select both dates');
//         }
//     };

//     const handleGeneratePDF = () => {
//         const printContent = document.getElementById('printable-table').innerHTML;  // Get the table HTML content
//         const printWindow = window.open('', '', 'height=600,width=800');  // Open a new print window
//         printWindow.document.write('<html><head><title>Print</title><style>');
//         printWindow.document.write(`
//             body { font-family: Arial, sans-serif; }
//             table { width: 100%; border-collapse: collapse; }
//             table, th, td { border: 1px solid black; }
//             th, td { padding: 8px; text-align: left; }
//         `);
//         printWindow.document.write('</style></head><body>');
//         printWindow.document.write(printContent);  // Insert the table HTML into the print window
//         printWindow.document.write('</body></html>');
//         printWindow.document.close();
//         printWindow.print();  // Trigger the print dialog
//     };

//     return (
//         <>
//             <Sidebar />
//             <div id="main">
//                 <Container>
//                     <h3>Panthullu Scanning QR Report</h3>
//                     <Row className="mt-3">
//                         <Col md={5}>
//                             <Form.Group>
//                                 <Form.Label>From Date</Form.Label>
//                                 <Form.Control
//                                     type="date"
//                                     value={date_1}
//                                     onChange={(e) => setDate1(e.target.value)}
//                                 />
//                             </Form.Group>
//                         </Col>
//                         <Col md={5}>
//                             <Form.Group>
//                                 <Form.Label>To Date</Form.Label>
//                                 <Form.Control
//                                     type="date"
//                                     value={date_2}
//                                     onChange={(e) => setDate2(e.target.value)}
//                                 />
//                             </Form.Group>
//                         </Col>
//                         <Col md={2} className="d-flex align-items-end">
//                             <Button variant="success" onClick={handleDateSubmit}>
//                                 Submit
//                             </Button>
//                         </Col>
//                     </Row>

//                     <Row className="mt-3">
//                         <Col>
//                             {/* Wrap the table with the ID 'printable-table' */}
//                             <div id="printable-table">
//                                 <Table striped bordered hover>
//                                     <thead>
//                                         <tr>

//                                             <th>QR Image</th>
//                                             <th>product Name</th>
//                                             <th>Units</th>
//                                             <th>Quantity</th>
//                                             <th>Price</th>




//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                         {loading ? (
//                                             <tr>
//                                                 <td colSpan="4">Loading...</td>
//                                             </tr>
//                                         ) : (
//                                             data.map((row, index) => (
//                                                 <tr key={index}>


//                                                     <td>
//                                                         <img src={row.qrimg} alt="QR Code" width="100" height="100" />
//                                                     </td>

//                                                     <td>{row.cat_name}</td>
//                                                     <td>{row.units}</td>
//                                                     <td>{row.quantity}</td>
//                                                     <td>{row.pricee}</td>




//                                                 </tr>
//                                             ))
//                                         )}
//                                     </tbody>
//                                 </Table>
//                             </div>

//                             <div className="text-center">
//                                 <Button variant="primary" onClick={handleGeneratePDF}>
//                                     Print
//                                 </Button>
//                             </div>
//                         </Col>
//                     </Row>
//                 </Container>
//             </div>
//         </>
//     );
// }

// export default StockReport;


// import React, { useState } from 'react';
// import axios from 'axios';
// import { Button, Table, Form, Container, Row, Col } from 'react-bootstrap';
// import Sidebar from '../Sidebar/Sidebar';

// function StockReport() {
//     const [date_1, setDate1] = useState('');
//     const [date_2, setDate2] = useState('');
//     const [data, setData] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [groupedData, setGroupedData] = useState([]);

//     const handleDateSubmit = async () => {
//         if (date_1 && date_2) {
//             setLoading(true);
//             try {
//                 const response = await axios.post('https://posapi.emedha.in/api/getPurchasesWithStock', {
//                     date_1,
//                     date_2
//                 });
//                 setData(response.data);
//                 groupDataByPurchasesid(response.data); // Group data by purchasesid
//             } catch (error) {
//                 console.error('Error fetching data:', error);
//             }
//             setLoading(false);
//         } else {
//             alert('Please select both dates');
//         }
//     };

//     const groupDataByPurchasesid = (data) => {
//         const grouped = data.reduce((result, item) => {
//             const { purchasesid } = item;
//             if (!result[purchasesid]) {
//                 result[purchasesid] = [];
//             }
//             result[purchasesid].push(item);
//             return result;
//         }, {});

//         const result = Object.keys(grouped).map((purchasesid) => {
//             const items = grouped[purchasesid];
//             const totalPrice = items.reduce((acc, item) => acc + parseFloat(item.pricee || 0), 0);
//             const totalScannedPrice = items.reduce((acc, item) => item.flag === 0 ? acc + parseFloat(item.pricee || 0) : acc, 0);
//             const totalBillAmount = items.length > 0 ? parseFloat(items[0].billamount || 0) : 0;
//             const remainingPrice = totalBillAmount - totalScannedPrice;

//             return {
//                 purchasesid,
//                 totalPrice,
//                 totalScannedPrice,
//                 remainingPrice,
//                 items,
//             };
//         });

//         setGroupedData(result); // Update state with grouped data
//     };

//     const handleGeneratePDF = () => {
//         const printContent = document.getElementById('printable-table').innerHTML;
//         const printWindow = window.open('', '', 'height=600,width=800');
//         printWindow.document.write('<html><head><title>Print</title><style>');
//         printWindow.document.write(`
//             body { font-family: Arial, sans-serif; }
//             table { width: 100%; border-collapse: collapse; }
//             table, th, td { border: 1px solid black; }
//             th, td { padding: 8px; text-align: left; }
//         `);
//         printWindow.document.write('</style></head><body>');
//         printWindow.document.write(printContent);
//         printWindow.document.write('</body></html>');
//         printWindow.document.close();
//         printWindow.print();
//     };

//     return (
//         <>
//             <Sidebar />
//             <div id="main">
//                 <Container>
//                     <h3>Panthullu Scanning QR Report</h3>
//                     <Row className="mt-3">
//                         <Col md={5}>
//                             <Form.Group>
//                                 <Form.Label>From Date</Form.Label>
//                                 <Form.Control
//                                     type="date"
//                                     value={date_1}
//                                     onChange={(e) => setDate1(e.target.value)}
//                                 />
//                             </Form.Group>
//                         </Col>
//                         <Col md={5}>
//                             <Form.Group>
//                                 <Form.Label>To Date</Form.Label>
//                                 <Form.Control
//                                     type="date"
//                                     value={date_2}
//                                     onChange={(e) => setDate2(e.target.value)}
//                                 />
//                             </Form.Group>
//                         </Col>
//                         <Col md={2} className="d-flex align-items-end">
//                             <Button variant="success" onClick={handleDateSubmit}>
//                                 Submit
//                             </Button>
//                         </Col>
//                     </Row>

//                     <Row className="mt-3">
//                         <Col>
//                             <div id="printable-table">
//                                 {loading ? (
//                                     <div>Loading...</div>
//                                 ) : (
//                                     groupedData.map((group, index) => (
//                                         <div key={index}>
//                                             <h4>Purchases ID: {group.purchasesid}</h4>
//                                             <Table striped bordered hover>
//                                                 <thead>
//                                                     <tr>
//                                                         <th>QR Image</th>
//                                                         <th>Product Name</th>
//                                                         <th>Units</th>
//                                                         <th>Quantity</th>
//                                                         <th>Price</th>
//                                                     </tr>
//                                                 </thead>
//                                                 <tbody>
//                                                     {group.items.map((row, idx) => (
//                                                         <tr key={idx}>
//                                                             <td>
//                                                                 <img
//                                                                     src={row.qrimg}
//                                                                     alt="QR Code"
//                                                                     width="100"
//                                                                     height="100"
//                                                                 />
//                                                             </td>
//                                                             <td>{row.cat_name}</td>
//                                                             <td>{row.units}</td>
//                                                             <td>{row.quantity}</td>
//                                                             <td>{row.pricee}</td>
//                                                         </tr>
//                                                     ))}
//                                                 </tbody>
//                                             </Table>

//                                             <div className="text-center mt-4">
//                                                 <h5>Total Price: {group.totalPrice}</h5>
//                                                 <h5>Total Scanned Price (flag 0): {group.totalScannedPrice}</h5>
//                                                 <h5>Remaining Price: {group.remainingPrice}</h5>
//                                             </div>
//                                         </div>
//                                     ))
//                                 )}
//                             </div>

//                             <div className="text-center mt-4">
//                                 <Button variant="primary" onClick={handleGeneratePDF}>
//                                     Print
//                                 </Button>
//                             </div>
//                         </Col>
//                     </Row>
//                 </Container>
//             </div>
//         </>
//     );
// }

// export default StockReport;



// import React, { useState } from 'react';
// import axios from 'axios';
// import { Button, Table, Form, Container, Row, Col } from 'react-bootstrap';
// import Sidebar from '../Sidebar/Sidebar';

// function StockReport() {
//     const [date_1, setDate1] = useState('');
//     const [date_2, setDate2] = useState('');
//     const [data, setData] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [groupedData, setGroupedData] = useState([]);

//     const handleDateSubmit = async () => {
//         if (date_1 && date_2) {
//             setLoading(true);
//             try {
//                 const response = await axios.post('https://posapi.emedha.in/api/getPurchasesWithStock', {
//                     date_1,
//                     date_2
//                 });
//                 setData(response.data);
//                 groupDataByPurchasesid(response.data); // Group data by purchasesid
//             } catch (error) {
//                 console.error('Error fetching data:', error);
//             }
//             setLoading(false);
//         } else {
//             alert('Please select both dates');
//         }
//     };

//     const groupDataByPurchasesid = (data) => {
//         const grouped = data.reduce((result, item) => {
//             const { purchasesid } = item;
//             if (!result[purchasesid]) {
//                 result[purchasesid] = [];
//             }
//             result[purchasesid].push(item);
//             return result;
//         }, {});

//         const result = Object.keys(grouped).map((purchasesid) => {
//             const items = grouped[purchasesid];
//             const totalPrice = items.reduce((acc, item) => acc + parseFloat(item.pricee || 0), 0);
//             const totalScannedPriceFlag0 = items.reduce((acc, item) => item.flag === 0 ? acc + parseFloat(item.pricee || 0) : acc, 0);
//             const totalScannedPriceFlag1 = items.reduce((acc, item) => item.flag === 1 ? acc + parseFloat(item.pricee || 0) : acc, 0);
//             const totalBillAmount = items.length > 0 ? parseFloat(items[0].billamount || 0) : 0;

//             let remainingPrice = totalBillAmount;

//             // Adjust remaining price based on flag 0 and flag 1 logic
//             if (totalScannedPriceFlag0 === 0) {
//                 // If no scanned price for flag 0, show remaining as total bill amount
//                 remainingPrice = totalBillAmount;
//             } else if (totalScannedPriceFlag1 > 0) {
//                 // If flag 1 exists, subtract from total bill amount
//                 remainingPrice = totalBillAmount - totalScannedPriceFlag1;
//             }

//             return {
//                 purchasesid,
//                 totalPrice,
//                 totalScannedPriceFlag0,
//                 totalScannedPriceFlag1,
//                 remainingPrice,
//                 items,
//             };
//         });

//         setGroupedData(result); // Update state with grouped data
//     };

//     // const handleGeneratePDF = () => {
//     //     const printContent = document.getElementById('printable-table').innerHTML;
//     //     const printWindow = window.open('', '', 'height=600,width=800');
//     //     printWindow.document.write('<html><head><title>Print</title><style>');
//     //     printWindow.document.write(`
//     //         body { font-family: Arial, sans-serif; }
//     //         table { width: 100%; border-collapse: collapse; }
//     //         table, th, td { border: 1px solid black; }
//     //         th, td { padding: 8px; text-align: left; }
//     //     `);
//     //     printWindow.document.write('</style></head><body>');
//     //     printWindow.document.write(printContent);
//     //     printWindow.document.write('</body></html>');
//     //     printWindow.document.close();
//     //     printWindow.print();
//     // };

//     const handleGeneratePDF = () => {
//         const printContent = document.getElementById('printable-table').innerHTML;
//         const printWindow = window.open('', '', 'height=600,width=800');
    
//         // Write the document structure
//         printWindow.document.write('<html><head><title>Print</title>');
    
//         // Add the Font Awesome CDN link for icons
//         printWindow.document.write('<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css">');
    
//         // Add custom styles for print
//         printWindow.document.write(`
//             <style>
//                 body { font-family: Arial, sans-serif; }
//                 table { width: 100%; border-collapse: collapse; }
//                 table, th, td { border: 1px solid black; }
//                 th, td { padding: 8px; text-align: left; }
//                 .fa-qrcode { font-size: 24px; }
//                 .fa-qrcode.red { color: red; text-decoration: line-through; }
//                 .fa-qrcode.green { color: green; }
//             </style>
//         `);
    
//         printWindow.document.write('</head><body>');
//         printWindow.document.write(printContent);
//         printWindow.document.write('</body></html>');
    
//         // Close the document and trigger the print
//         printWindow.document.close();
//         printWindow.print();
//     };
    


//     return (
//         <>
//             <Sidebar />
//             <div id="main">
//                 <Container>
//                     <h3>Stock QR Report</h3>
//                     <Row className="mt-3">
//                         <Col md={5}>
//                             <Form.Group>
//                                 <Form.Label>From Date</Form.Label>
//                                 <Form.Control
//                                     type="date"
//                                     value={date_1}
//                                     onChange={(e) => setDate1(e.target.value)}
//                                 />
//                             </Form.Group>
//                         </Col>
//                         <Col md={5}>
//                             <Form.Group>
//                                 <Form.Label>To Date</Form.Label>
//                                 <Form.Control
//                                     type="date"
//                                     value={date_2}
//                                     onChange={(e) => setDate2(e.target.value)}
//                                 />
//                             </Form.Group>
//                         </Col>
//                         <Col md={2} className="d-flex align-items-end">
//                             <Button variant="success" onClick={handleDateSubmit}>
//                                 Submit
//                             </Button>
//                         </Col>
//                     </Row>

//                     <Row className="mt-3">
//                         <Col>
//                             <div id="printable-table">
//                                 {loading ? (
//                                     <div>Loading...</div>
//                                 ) : (
//                                     groupedData.map((group, index) => (
//                                         <div key={index}>
//                                             {/* <h4>Purchases ID: {group.purchasesid}</h4> */}
//                                             <Table striped bordered hover>
//                                                 <thead>
//                                                     <tr>
//                                                         <th>QR Image</th>
//                                                         <th>Product Name</th>
                                                        
//                                                         <th>Quantity</th>
//                                                         <th>Units</th>
//                                                         <th>Price</th>
//                                                         <th>Scanned</th>
//                                                     </tr>
//                                                 </thead>
//                                                 <tbody>
//                                                     {group.items.map((row, idx) => (
//                                                         <tr key={idx}>
//                                                             <td>
//                                                                 <img
//                                                                     src={row.qrimg}
//                                                                     alt="QR Code"
//                                                                     width="100"
//                                                                     height="100"
//                                                                 />
//                                                             </td>
//                                                             <td>{row.cat_name}</td>
//                                                             <td>{row.quantity}</td>
//                                                             <td>{row.units}</td>
                                                            
//                                                             <td>{row.pricee}</td>
//                                                             <td>
//                                                                 {row.flag === 0 ? (
//                                                                     <i className="fa fa-qrcode" style={{ color: 'red', textDecoration: 'line-through' }}></i>  // Strikethrough red QR code if flag is 0
//                                                                 ) : (
//                                                                     <i className="fa fa-qrcode" style={{ color: 'green' }}></i>  // Green QR code if flag is 1
//                                                                 )}
//                                                             </td>

//                                                         </tr>
//                                                     ))}
//                                                 </tbody>
//                                             </Table>

//                                             <div className="text-center mt-4">
//                                             <h5>Total Purchase Stock from {group.items[0].cat_name}: {group.totalPrice}</h5>
                                            
//                                             <h5 style={{color:'green'}}> Issued Stock from {group.items[0].cat_name}: {group.totalScannedPriceFlag1}</h5>

//                                                 <h5 style={{color:'red'}}>Stock from {group.items[0].cat_name} : {group.totalScannedPriceFlag0}</h5>
                                              
//                                                 {/* {group.totalScannedPriceFlag0 === 0 && (
//                                                     <h5> Total Remaining Price from {group.items[0].cat_name}: {group.remainingPrice}</h5>
//                                                 )}

//                                                 {group.totalScannedPriceFlag1 > 0 && (
//                                                     <h5>Total Remaining Price from {group.items[0].cat_name}: {group.remainingPrice}</h5>
//                                                 )} */}
//                                             </div>
//                                         </div>
//                                     ))
//                                 )}
//                             </div>

//                             <div className="text-center mt-4">
//                                 <Button variant="primary" onClick={handleGeneratePDF}>
//                                     Print
//                                 </Button>
//                             </div>
//                         </Col>
//                     </Row>
//                 </Container>
//             </div>
//         </>
//     );
// }

// export default StockReport;



import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Sidebar from '../Sidebar/Sidebar';

// SVG Icons
const Icons = {
  Search: (size = 16) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="11" cy="11" r="8"></circle>
      <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
    </svg>
  ),
  Printer: (size = 16) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="6 9 6 2 18 2 18 9"></polyline>
      <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
      <rect x="6" y="14" width="12" height="8"></rect>
    </svg>
  ),
  CheckCircle: (size = 16) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
      <polyline points="22 4 12 14.01 9 11.01"></polyline>
    </svg>
  ),
  XCircle: (size = 16) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="15" y1="9" x2="9" y2="15"></line>
      <line x1="9" y1="9" x2="15" y2="15"></line>
    </svg>
  )
};

function StockReport() {
  const [date_1, setDate1] = useState('');
  const [date_2, setDate2] = useState('');
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [groupedData, setGroupedData] = useState([]);

  // Responsive state
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleDateSubmit = async () => {
    if (date_1 && date_2) {
      setLoading(true);
      try {
        const response = await axios.post('https://posapi.emedha.in/api/getPurchasesWithStock', {
          date_1,
          date_2
        });
        setData(response.data);
        groupDataByPurchasesid(response.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
      setLoading(false);
    } else {
      alert('Please select both dates');
    }
  };

  const groupDataByPurchasesid = (data) => {
    const grouped = data.reduce((result, item) => {
      const { purchasesid } = item;
      if (!result[purchasesid]) {
        result[purchasesid] = [];
      }
      result[purchasesid].push(item);
      return result;
    }, {});

    const result = Object.keys(grouped).map((purchasesid) => {
      const items = grouped[purchasesid];
      const totalPrice = items.reduce((acc, item) => acc + parseFloat(item.pricee || 0), 0);
      const totalScannedPriceFlag0 = items.reduce((acc, item) => item.flag === 0 ? acc + parseFloat(item.pricee || 0) : acc, 0);
      const totalScannedPriceFlag1 = items.reduce((acc, item) => item.flag === 1 ? acc + parseFloat(item.pricee || 0) : acc, 0);
      const totalBillAmount = items.length > 0 ? parseFloat(items[0].billamount || 0) : 0;

      let remainingPrice = totalBillAmount;

      if (totalScannedPriceFlag0 === 0) {
        remainingPrice = totalBillAmount;
      } else if (totalScannedPriceFlag1 > 0) {
        remainingPrice = totalBillAmount - totalScannedPriceFlag1;
      }

      return {
        purchasesid,
        totalPrice,
        totalScannedPriceFlag0,
        totalScannedPriceFlag1,
        remainingPrice,
        items,
      };
    });

    setGroupedData(result);
  };

  const handleGeneratePDF = () => {
    const printContent = document.getElementById('printable-table').innerHTML;
    const printWindow = window.open('', '', 'height=600,width=800');

    printWindow.document.write('<html><head><title>Stock QR Report</title>');
    printWindow.document.write(`
      <style>
        body { font-family: system-ui, -apple-system, sans-serif; background-color: #ffffff; padding: 20px; color: #111827; }
        table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
        th, td { border: 1px solid #fed7aa; padding: 10px 12px; text-align: left; font-size: 13px; }
        th { background-color: #fff7ed; color: #c2410c; font-weight: bold; }
        img { width: 60px; height: 60px; object-fit: contain; }
        .summary-card { background: #fff7ed; padding: 14px; border-radius: 8px; margin-bottom: 24px; border: 1px solid #fed7aa; }
        .scanned-issued { color: #15803d; font-weight: bold; }
        .scanned-remaining { color: #dc2626; font-weight: bold; }
      </style>
    `);
    printWindow.document.write('</head><body>');
    printWindow.document.write(printContent);
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    printWindow.print();
  };

  // Overall calculations across all grouped items
  const overallTotal = groupedData.reduce((acc, g) => acc + g.totalPrice, 0);
  const overallIssued = groupedData.reduce((acc, g) => acc + g.totalScannedPriceFlag1, 0);
  const overallRemaining = groupedData.reduce((acc, g) => acc + g.totalScannedPriceFlag0, 0);

  return (
    <div 
    //style={{ display: 'flex', minHeight: '100vh', backgroundColor: '#fcfaf8' }}
    >
      <Sidebar />

      <div
        id="main"
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minWidth: 0,
          fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
        }}
      >
        <div
          style={{
            padding: isMobile ? '16px' : '28px',
            maxWidth: '1280px',
            width: '100%',
            margin: '0 auto',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            gap: '20px'
          }}
        >
          {/* Header & Date Pickers */}
          <div
            style={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              alignItems: isMobile ? 'flex-start' : 'center',
              justifyContent: 'space-between',
              gap: '16px',
              width: '100%'
            }}
          >
            <div>
              <h2
                style={{
                  margin: 0,
                  fontSize: isMobile ? '22px' : '26px',
                  fontWeight: '700',
                  color: '#111827',
                  fontFamily: "'Cinzel', serif"
                }}
              >
                Stock QR Report
              </h2>
              <p style={{ margin: '4px 0 0 0', fontSize: '14px', color: '#6b7280' }}>
                Analyze stock status and scanned item reports between dates
              </p>
            </div>

            {/* Filter Bar Controls */}
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                gap: '10px',
                width: isMobile ? '100%' : 'auto'
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  backgroundColor: '#ffffff',
                  padding: '8px 12px',
                  borderRadius: '12px',
                  border: '1px solid #ffedd5',
                  boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
                }}
              >
                <span style={{ fontSize: '12px', fontWeight: '600', color: '#6b7280' }}>From</span>
                <input
                  type="date"
                  value={date_1}
                  onChange={(e) => setDate1(e.target.value)}
                  style={{
                    outline: 'none',
                    border: 'none',
                    color: '#374151',
                    backgroundColor: 'transparent',
                    fontSize: '13px',
                    fontWeight: '500',
                    cursor: 'pointer'
                  }}
                />
              </div>

              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  backgroundColor: '#ffffff',
                  padding: '8px 12px',
                  borderRadius: '12px',
                  border: '1px solid #ffedd5',
                  boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
                }}
              >
                <span style={{ fontSize: '12px', fontWeight: '600', color: '#6b7280' }}>To</span>
                <input
                  type="date"
                  value={date_2}
                  onChange={(e) => setDate2(e.target.value)}
                  style={{
                    outline: 'none',
                    border: 'none',
                    color: '#374151',
                    backgroundColor: 'transparent',
                    fontSize: '13px',
                    fontWeight: '500',
                    cursor: 'pointer'
                  }}
                />
              </div>

              <button
                onClick={handleDateSubmit}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  padding: '10px 18px',
                  borderRadius: '12px',
                  fontSize: '13px',
                  fontWeight: '600',
                  color: '#ffffff',
                  background: 'linear-gradient(135deg, #f97316, #c2410c)',
                  boxShadow: '0 4px 16px rgba(249, 115, 22, 0.3)',
                  border: 'none',
                  cursor: 'pointer',
                  width: isMobile ? '100%' : 'auto'
                }}
              >
                <span>Submit</span>
              </button>

              {groupedData.length > 0 && (
                <button
                  onClick={handleGeneratePDF}
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '6px',
                    padding: '10px 16px',
                    borderRadius: '12px',
                    border: '1px solid #fed7aa',
                    backgroundColor: '#ffffff',
                    color: '#c2410c',
                    fontSize: '13px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
                    width: isMobile ? '100%' : 'auto'
                  }}
                >
                  {Icons.Printer(15)}
                  <span>Print Report</span>
                </button>
              )}
            </div>
          </div>

          {/* Top Summary Cards if data is loaded */}
          {groupedData.length > 0 && (
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
                gap: '16px',
                width: '100%'
              }}
            >
              <div
                style={{
                  backgroundColor: '#ffffff',
                  borderRadius: '16px',
                  border: '1px solid #ffedd5',
                  padding: '20px',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
                }}
              >
                <p style={{ margin: 0, fontSize: '24px', fontWeight: '700', color: '#ea580c' }}>
                  ₹{overallTotal.toLocaleString()}
                </p>
                <p style={{ margin: '4px 0 0 0', fontSize: '12px', fontWeight: '600', color: '#374151' }}>
                  Total Purchased Stock
                </p>
              </div>

              <div
                style={{
                  backgroundColor: '#ffffff',
                  borderRadius: '16px',
                  border: '1px solid #ffedd5',
                  padding: '20px',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
                }}
              >
                <p style={{ margin: 0, fontSize: '24px', fontWeight: '700', color: '#16a34a' }}>
                  ₹{overallIssued.toLocaleString()}
                </p>
                <p style={{ margin: '4px 0 0 0', fontSize: '12px', fontWeight: '600', color: '#374151' }}>
                  Total Issued Stock (Scanned)
                </p>
              </div>

              <div
                style={{
                  backgroundColor: '#ffffff',
                  borderRadius: '16px',
                  border: '1px solid #ffedd5',
                  padding: '20px',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
                }}
              >
                <p style={{ margin: 0, fontSize: '24px', fontWeight: '700', color: '#dc2626' }}>
                  ₹{overallRemaining.toLocaleString()}
                </p>
                <p style={{ margin: '4px 0 0 0', fontSize: '12px', fontWeight: '600', color: '#374151' }}>
                  Remaining Stock in Hand
                </p>
              </div>
            </div>
          )}

          {/* Printable & Screen Report Content */}
          <div id="printable-table" style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
            {loading ? (
              <div style={{ textAlign: 'center', padding: '50px 0', color: '#6b7280', fontSize: '14px' }}>
                Loading stock reports...
              </div>
            ) : groupedData.length > 0 ? (
              groupedData.map((group, index) => (
                <div
                  key={index}
                  style={{
                    backgroundColor: '#ffffff',
                    borderRadius: '16px',
                    border: '1px solid #ffedd5',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                    overflow: 'hidden'
                  }}
                >
                  <div style={{ width: '100%', overflowX: 'auto' }}>
                    <table
                      style={{
                        width: '100%',
                        minWidth: '750px',
                        borderCollapse: 'collapse',
                        textAlign: 'left'
                      }}
                    >
                      <thead>
                        <tr
                          style={{
                            backgroundColor: 'rgba(255, 247, 237, 0.6)',
                            borderBottom: '1px solid #ffedd5',
                            fontSize: '12px',
                            fontWeight: '600',
                            color: '#374151',
                            textTransform: 'uppercase',
                            letterSpacing: '0.05em'
                          }}
                        >
                          <th style={{ padding: '14px 20px', width: '120px' }}>QR Image</th>
                          <th style={{ padding: '14px 20px' }}>Product Name</th>
                          <th style={{ padding: '14px 20px' }}>Quantity</th>
                          <th style={{ padding: '14px 20px' }}>Units</th>
                          <th style={{ padding: '14px 20px' }}>Price</th>
                          <th style={{ padding: '14px 20px', textAlign: 'center' }}>Scanned Status</th>
                        </tr>
                      </thead>
                      <tbody style={{ fontSize: '14px' }}>
                        {group.items.map((row, idx) => (
                          <tr
                            key={idx}
                            style={{
                              borderBottom: '1px solid #fff7ed',
                              backgroundColor: '#ffffff'
                            }}
                          >
                            <td style={{ padding: '12px 20px' }}>
                              {row.qrimg ? (
                                <img
                                  src={row.qrimg}
                                  alt="QR Code"
                                  style={{
                                    width: '60px',
                                    height: '60px',
                                    objectFit: 'contain',
                                    borderRadius: '8px',
                                    border: '1px solid #fed7aa',
                                    padding: '2px',
                                    backgroundColor: '#ffffff',
                                    display: 'block'
                                  }}
                                />
                              ) : (
                                <span style={{ color: '#9ca3af', fontSize: '12px' }}>No QR</span>
                              )}
                            </td>
                            <td style={{ padding: '16px 20px', fontWeight: '600', color: '#111827' }}>
                              {row.cat_name}
                            </td>
                            <td style={{ padding: '16px 20px', color: '#4b5563' }}>
                              {row.quantity}
                            </td>
                            <td style={{ padding: '16px 20px', color: '#4b5563' }}>
                              {row.units}
                            </td>
                            <td style={{ padding: '16px 20px', fontWeight: '700', color: '#111827' }}>
                              ₹{Number(row.pricee || 0).toLocaleString()}
                            </td>
                            <td style={{ padding: '16px 20px', textAlign: 'center' }}>
                              {row.flag === 0 ? (
                                <span
                                  style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '4px',
                                    padding: '4px 10px',
                                    borderRadius: '9999px',
                                    fontSize: '12px',
                                    fontWeight: '600',
                                    backgroundColor: '#fef2f2',
                                    color: '#dc2626'
                                  }}
                                >
                                  {Icons.XCircle(14)} Not Scanned
                                </span>
                              ) : (
                                <span
                                  style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '4px',
                                    padding: '4px 10px',
                                    borderRadius: '9999px',
                                    fontSize: '12px',
                                    fontWeight: '600',
                                    backgroundColor: '#f0fdf4',
                                    color: '#15803d'
                                  }}
                                >
                                  {Icons.CheckCircle(14)} Issued (Scanned)
                                </span>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {/* Group Summary Footer Card */}
                  <div
                    style={{
                      padding: '16px 20px',
                      backgroundColor: 'rgba(255, 247, 237, 0.8)',
                      borderTop: '1px solid #ffedd5',
                      display: 'flex',
                      flexDirection: isMobile ? 'column' : 'row',
                      justifyContent: 'space-between',
                      alignItems: isMobile ? 'flex-start' : 'center',
                      gap: '8px',
                      fontSize: '13px',
                      fontWeight: '600'
                    }}
                  >
                    <span style={{ color: '#111827' }}>
                      Total Stock ({group.items[0]?.cat_name}): <span style={{ color: '#ea580c' }}>₹{group.totalPrice.toLocaleString()}</span>
                    </span>
                    <span style={{ color: '#15803d' }}>
                      Issued Stock: ₹{group.totalScannedPriceFlag1.toLocaleString()}
                    </span>
                    <span style={{ color: '#dc2626' }}>
                      Remaining Stock: ₹{group.totalScannedPriceFlag0.toLocaleString()}
                    </span>
                  </div>
                </div>
              ))
            ) : (
              <div
                style={{
                  backgroundColor: '#ffffff',
                  borderRadius: '16px',
                  border: '1px solid #ffedd5',
                  padding: '40px',
                  textAlign: 'center',
                  color: '#9ca3af',
                  fontSize: '14px'
                }}
              >
                No report data found. Please select a date range and click submit.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default StockReport;